"use client";

import React from "react";
import { useAppStore } from "@/store/useAppStore";
import { SocialFeatures } from "./SocialFeatures";
import { useAuth } from "@/hooks/useAuth";
import { UserMobileImage } from "./UserMobileImage";
import { ScoreCard } from "./ScoreCard";
import { SignOutMobileButton } from "../ui/SignOutMobileButton";
import { AuthMobileButton } from "../ui/AuthMobileButton";
import { MobileNavigationList } from "./MobileNavigationList";

export const HeaderMobileMenu = () => {
  const { isMenuOpen, setIsMenuOpen } = useAppStore();
  const { user } = useAuth();

  if (!isMenuOpen) return null;

  return (
    <div className="sm:hidden fixed inset-0 bg-black z-50">
      <div className="h-16 px-5 flex items-center justify-between border-b border-[#2A2A2A]">
        <span className="text-xl font-bold text-white tracking-[-0.5px]">Probabl</span>
        <button
          onClick={() => setIsMenuOpen(false)}
          className="w-10 h-10 flex items-center justify-center text-white text-lg cursor-pointer"
        >
          ✕
        </button>
      </div>

      <div className="px-5 py-8">
        <div className="flex flex-col gap-6">
          {!user ? (
            <div className="flex justify-center">
              <AuthMobileButton />
            </div>
          ) : (
            <div className="flex items-center gap-4 mb-2">
              <UserMobileImage />
              <ScoreCard />
              <SocialFeatures />
            </div>
          )}

          <MobileNavigationList />

          {user && (
            <div className="pt-4 border-t border-[#2A2A2A]">
              <SignOutMobileButton />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
